import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { DeepLinkingService } from '@core/services/deep-linking.service';
import { PortalDeterminationService } from '@core/services/portal-determination.service';
import { SpinnerService } from '@core/services/spinner.service';
import { SSOService } from '@core/services/sso.service';
import { LoginBehaviors } from '@core/typings/login-behaviors.typing';

@Component({
  selector: 'gc-bbid-new-user',
  templateUrl: './bbid-new-user.component.html',
  styleUrls: ['./bbid-new-user.component.scss']
})
export class BbidNewUserComponent implements OnInit {
  email = this.activatedRoute.snapshot.queryParams.email;
  inSystem = this.activatedRoute.snapshot.queryParams.inSystem === 'true' ? true : false;
  grantProgramGuid = this.activatedRoute.snapshot.queryParams.grantProgramGuid;
  invitationId = this.activatedRoute.snapshot.queryParams.invitationId;

  constructor (
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private spinner: SpinnerService,
    private deepLinkingService: DeepLinkingService,
    private ssoService: SSOService,
    private router: Router,
    private portal: PortalDeterminationService
  ) { }

  async ngOnInit () {
    let proceedToBbid = true;
    if (!!this.ssoService.ssoConfig && this.portal.isManager) {
      // We had a bug (3292067) where we sent potential non BBID grant managers a link to this route.
      // To handle existing emails, we should only proceed on to BBID if we actually know they are not using SSO
      // Else, send them to the login page to choose how to proceed
      proceedToBbid = this.ssoService.ssoConfig.loginBehavior === LoginBehaviors.PlainLogin;
    }
    if (proceedToBbid) {
      this.spinner.startSpinner();
      if (!!this.grantProgramGuid) {
        let route = `/apply/programs/${this.grantProgramGuid}`;
        if (!!this.invitationId) {
          route = route + `?invite=${this.invitationId}`;
        }
        this.deepLinkingService.setAttemptedRoute(route);
      }
      await this.authService.handleNewUserSlatedForBbid(this.inSystem, this.email);
      this.spinner.stopSpinner();
    } else {
      this.router.navigateByUrl(`/management/auth/signin`);
    }
  }
}
